import { render, staticRenderFns } from "./SubSetting2.vue?vue&type=template&id=23ec2c5d"
import script from "./SubSetting2.vue?vue&type=script&lang=js"
export * from "./SubSetting2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports